// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * RendererCell — shows an eye icon if the renderer has analysis results,
 * otherwise shows a dash. Clicking opens the preview for that renderer.
 */
import { type FC } from 'react'
import { Eye } from 'lucide-react'

import { Button } from '@/components/ui/button'
import type { RendererDefinition } from '@/app-shell/types'

interface RendererCellProps {
  rendererId: string
  renderer: RendererDefinition
  hasAnalysis: boolean
  onView: (rendererId: string) => void
}

export const RendererCell: FC<RendererCellProps> = ({
  rendererId,
  renderer,
  hasAnalysis,
  onView,
}) => {
  if (!hasAnalysis) {
    return <span className="text-muted-foreground">—</span>
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      className="h-7 w-7"
      onClick={() => onView(rendererId)}
      title={`View ${renderer.label}`}
    >
      <Eye className="h-4 w-4" />
    </Button>
  )
}
